import NavDropdownNav from "./nav-dropdown-navigate";
import NavDropdownList from "./nav-dropdown-lists";
import NavProfile from "./nav-profile";
import logo from "../../images/logo.png";
import "./nav.css";
import { Link } from "react-router-dom";

export const Nav = (props) => {
  return (
    <div id="nav-container">
      {!props.loading && (
        <>
          <Link to={"/dashboard"}>
            <img id="logo" alt="logo" src={logo} />
          </Link>
          <div id="nav-items-container">
            <NavDropdownList />
            <NavDropdownNav />
            <NavProfile />
          </div>
        </>
      )}
    </div>
  );
};
